import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormField } from '../../_shared/formfield/formfield.component'; // React-helmet handles document head modifications (title, meta data etc)
import SubmissionHandler from '../../_shared/submissionhandler/submissionhandler';
import Header from '../../_shared/header/header';
import Footer from '../../_shared/footer/footer';
import flatten from '../../_shared/util/flatten';
import getTitles from '../../_shared/util/getTitles';
import { Helmet } from 'react-helmet';
import EmailLinkModal from '../../_shared/emaillink/emaillinkmodal.component';

@inject('livingRoomStore', 'appStore', 'routerStore', 'store', 'form')
@observer
export class CeilingComponent extends Component {
    constructor(props) {
        super(props);
        this.emailModal = React.createRef();
    }

    onNext(e) {
        const { livingRoomStore, routerStore, appStore } = this.props,
            { history } = routerStore;
        let livingRoomNum = livingRoomStore.currentRoomNum,
            dest;

        if (livingRoomNum >= livingRoomStore.numRooms) {
            dest = appStore.submissionID ? `/result/${appStore.submissionID}` : '/result';
        } else {
            livingRoomNum = livingRoomStore.currentRoomNum + 1;
            dest = `/livingroom/${livingRoomNum}/walls`;
        }

        history.push({ pathname: dest, state: { transition: 'forward' } });
    }

    onPrevious() {
        const { livingRoomStore, routerStore, store, form } = this.props,
            { history } = routerStore;

        store.save(form.values(), false);

        history.push({ pathname: `/livingroom/${livingRoomStore.currentRoomNum}/floor`, state: { transition: 'back' } });
    }

    render() {
        const { form, store, livingRoomStore, appStore } = this.props,
            errors = form.errors(),
            titles = getTitles(livingRoomStore.currentRoomNum, 'Ceiling details'),
            idPrefix = `ceiling-${livingRoomStore.currentRoomNum}`,
            footerButtonText = livingRoomStore.currentRoomNum < livingRoomStore.numRooms
                ? `Go to level ${livingRoomStore.currentRoomNum + 1} wall details` // go to next room
                : 'Go to results',
            prevActionName = `prev-${livingRoomStore.currentRoomNum}-ceiling-to-floor`,
            nextActionName = livingRoomStore.currentRoomNum < livingRoomStore.numRooms
                ? `next-${livingRoomStore.currentRoomNum}-ceiling-to-walls-${livingRoomStore.currentRoomNum + 1}`
                : `next-${livingRoomStore.currentRoomNum}-ceiling-to-result`,
            emailActionName = `email-${livingRoomStore.currentRoomNum}-ceiling`;

        return <section className='ht-page ht-ceiling'>
            <Helmet>
                <title>{titles.title} &raquo; {appStore.baseTitle}</title>
            </Helmet>
            <Header
                titlePre={titles.titlePre}
                title={titles.title}
                idPrefix={idPrefix}
                prevActionName={prevActionName}
                emailActionName={emailActionName}
                prev={{
                    onClick: () => this.onPrevious()
                }}
                email={{
                    modal: this.emailModal
                }}
            />
            <SubmissionHandler store={store}>
                <form className='ht-form'>
                    {form.map(field => {
                        field.errors = errors[field.path];
                        return (
                            <FormField
                                key={field.id}
                                field={field}
                                formValues={flatten(form.values())}
                            />
                        );
                    })}
                    <Footer
                        idPrefix={idPrefix}
                        prevActionName={prevActionName}
                        nextActionName={nextActionName}
                        emailActionName={emailActionName}
                        next={{
                            text: footerButtonText,
                            loading: store.loading,
                            disabled: !form.isValid || (store.error && store.error.code),
                            onClick: e => form.onSubmit(e)
                        }}
                        prev={{
                            onClick: () => this.onPrevious()
                        }}
                        email={{
                            modal: this.emailModal
                        }}
                        showError={!form.isValid}
                        errorMessage={form.error}
                        emailProgressLinkSupText={window.HTContent.EmailProgressLinkSupText}
                    />
                </form>
            </SubmissionHandler>
            <EmailLinkModal
                ref={this.emailModal}
                onOpenCallback={() => store.save(form.values(), false)}
            />
        </section>;
    }
}
